import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { ApplyTagWithFieldSelectDialog } from 'field-shared/dialogs/apply-tag-with-field-select/apply-tag-with-field-select.dialog';
import { filterGroupCategoriesByArchiveStatus } from 'field-shared/field-helper-functions';
import { CalendarEventWithUsersAndCountsFragment, CalendarEventResponseCoreFragment, GetTagGroups2GQL, TagGroupInfoFragment } from 'generated/graphql';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-event-response-tags',
  templateUrl: './event-response-tags.component.html',
  styleUrls: ['./event-response-tags.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventResponseTagsComponent
  extends WithDisposableSubject() implements OnInit {

  @Input() calendarEvent: CalendarEventWithUsersAndCountsFragment;
  @Input() calendarEventResponse: CalendarEventResponseCoreFragment;

  campaignId: string;
  tagGroups: TagGroupInfoFragment[];

  constructor(
    private _cd: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _dialog: MatDialog,
    private _getTagGroups2: GetTagGroups2GQL,
  ) {
    super();

    this.campaignId = this._route.snapshot.queryParams.campaignId;
  }

  ngOnInit() {
    this._getTagGroupsForCalendarEvent(
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe((groups) => {
      this.tagGroups = groups;
      this._cd.markForCheck();
    });
  }

  addInfoClick() {
    ApplyTagWithFieldSelectDialog.open(this._dialog, {
      data: {
        targetType: 'CalendarEventType',
        targetTypeId: null,
        targetId: this.calendarEventResponse.id,
        campaignId: this.campaignId
      }
    });
  }

  private _getTagGroupsForCalendarEvent() {
    return this._getTagGroups2.watch({
      targetType: 'CalendarEventType',
      campaignId: this.campaignId,
    }).valueChanges.pipe(
      map(({ data }) => data.getTagGroups.nodes),
      map(groups => filterGroupCategoriesByArchiveStatus(groups, 'Active')
        .filter(c => c.categories.length > 0))
    );
  }
}
